import ChannelTalk from './channelTalkIcon.svg?react';

/**
 *
 */
export default function ChannelTalkIcon() {
  return <ChannelTalk />;
}
